import OperatorsApiManager from '../../api/services/OperatorsApiManager'
import Table from 'react-bootstrap/Table'
import { ToastContainer, toast } from 'react-toastify'

import { DragDropContext, Draggable, Droppable } from '@hello-pangea/dnd'
import { useState, useEffect } from 'react'
import {
    Button,
    Modal,
    FormCheck,
    OverlayTrigger,
    Tooltip,
} from 'react-bootstrap'
import { Link } from 'react-router-dom'
import BannersApiManager from '../../api/services/BannersApiManager'
import { Trans, useTranslation } from 'react-i18next'

// a little function to help us with reordering the result
const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list)
    const [removed] = result.splice(startIndex, 1)
    result.splice(endIndex, 0, removed)

    return result
}
const getItemStyle = (isDragging, draggableStyle) => ({
    // some basic styles to make the items look a bit nicer
    userSelect: 'none',

    // change background colour if dragging
    background: isDragging ? 'white' : 'grey',

    // styles we need to apply on draggables
    ...draggableStyle,
})
const getListStyle = (isDraggingOver) => ({
    background: isDraggingOver ? 'lightblue' : 'lightgrey',
})

function Banners() {
    const { t } = useTranslation()
    const [bannersData, setBannersData] = useState([])
    const [banners, setBanners] = useState([])
    const [showDeleteBanner, setShowDeleteBanner] = useState(false)
    const [selectedBanner, setSelectedBanner] = useState(null)
    const [selectedOperator, setSelectedOperator] = useState(null)
    const [lastPosition, setLastPosition] = useState(1)
    useEffect(() => {
        var operatorData = localStorage.getItem('operador')
        var operator = JSON.parse(operatorData)

        fetchBanners()
        setSelectedOperator(operator)
    }, [])
    async function fetchBanners() {
        const bannersItems = await OperatorsApiManager.getOperatorBanners()
        setBannersData(bannersItems)
        setBanners(bannersItems)
        setLastPosition(
            bannersItems.length > 0
                ? parseInt(
                      bannersItems[bannersItems.length - 1].field_position
                  ) + 1
                : 1
        )
    }

    const handleDeleteBanner = async (banner) => {
        const response = await BannersApiManager.deleteBanner(banner.nid).catch(
            (error) => {
                console.error(error)
                setShowDeleteBanner(false)
                toast.error(error.message)
            }
        )

        if (response) {
            setBanners((prevBanners) =>
                prevBanners.filter((item) => item.nid !== banner.nid)
            )
            setShowDeleteBanner(false)

            toast.success(t('alerts.banner_deleted'))
        }
    }

    const handleToggleBanner = async (nodeId, active) => {
        const response = await BannersApiManager.toggleActiveBanner(
            nodeId,
            active
        )
        if (response) {
            const newBanners = banners.map((banner) => {
                if (banner.nid === nodeId) {
                    return {
                        ...banner,
                        field_active_banner: active ? 'On' : 'Off',
                    }
                }
                return banner
            })
            setBanners(newBanners)

            setLastPosition(
                newBanners.length > 0
                    ? parseInt(
                          newBanners[newBanners.length - 1].field_position
                      ) + 1
                    : 1
            )
        }
    }

    const onDragEnd = async (result) => {
        // dropped outside the list
        if (!result.destination) {
            return
        }

        const items = reorder(
            banners,
            result.source.index,
            result.destination.index
        )

        // update the position of the items
        const newItems = items.map((item, index) => {
            return {
                ...item,
                field_position: index + 1,
            }
        })
        // update the state with the new items
        setBanners(newItems)
        // update the position of the items in the backend
        await Promise.all(
            newItems.map(async (item) => {
                await BannersApiManager.updateBannerPosition(
                    item.nid,
                    item.field_position
                )
            })
        )
    }
    return (
        <div>
            <ToastContainer />
            <div className="page-header">
                <h3 className="page-title">{selectedOperator?.group_name}</h3>
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item">
                            <Link to="/operadores" className="breadcrumb-link">
                                {t('operators_title')}
                            </Link>
                        </li>
                        <li
                            className="breadcrumb-item active"
                            aria-current="page"
                        >
                            {t('banners_title')}
                        </li>
                    </ol>
                </nav>
            </div>
            <div className="row">
                <div className="col-lg-12 grid-margin stretch-card">
                    <div className="card">
                        <div className="card-body">
                            <div className="row">
                                <div className="col col-sm-5 col-md-4 col-lg-2">
                                    <h4 className="card-title mt-2">
                                        {t('banners_operator_title')}
                                    </h4>
                                </div>
                                <Link
                                    className="col-2"
                                    to={`/operadores/banners/formulario`}
                                    state={{
                                        lastPosition: lastPosition,
                                        banners: banners,
                                        banner: null,
                                        isEdit: false,
                                        isCreate: true,
                                        title: t('create_banner')
                                    }}
                                >
                                    <Button
                                        className="ml-auto"
                                        variant="primary btn-icon btn-lg btn-rounded"
                                    >
                                        <i className="mdi mdi-plus btn-icon-prepend"></i>
                                    </Button>
                                </Link>
                            </div>
                            <div className="row mt-4">
                                <div className="row">
                                    <div className="col-md-6">
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder={t('search_placeholder')}
                                            onChange={(e) => {
                                                if (e.target.value === '') {
                                                    setBanners(bannersData)
                                                    return
                                                }

                                                const searchTerm =
                                                    e.target.value.toLowerCase()
                                                const filteredBanners =
                                                    bannersData.filter(
                                                        (banner) =>
                                                            banner.title
                                                                .toLowerCase()
                                                                .includes(
                                                                    searchTerm
                                                                ) ||
                                                            banner.nid
                                                                .toLowerCase()
                                                                .includes(
                                                                    searchTerm
                                                                )
                                                    )
                                                setBanners(filteredBanners)
                                            }}
                                        />
                                    </div>
                                    <div className="col-md-6 text-right text-center mt-4">
                                        <span className="text-muted">
                                            {t('banners_count')}
                                            <strong>{bannersData.length}</strong>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <DragDropContext onDragEnd={onDragEnd}>
                                <Droppable droppableId="droppable">
                                    {(provided, snapshot) => (
                                        <div className="table-responsive">
                                            <Table
                                                ref={provided.innerRef}
                                                style={getListStyle(
                                                    snapshot.isDraggingOver
                                                )}
                                            >
                                                <thead>
                                                    <tr>
                                                        <th>ID</th>
                                                        <th>{t('title_title')}</th>
                                                        <th>{t('image_title')}</th>
                                                        <th>{t('image_mobile_title')}</th>
                                                        <th>{t('active_title')}</th>
                                                        <th>{t('options_title')}</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {banners.map(
                                                        (item, index) => (
                                                            <Draggable
                                                                key={item.nid}
                                                                draggableId={
                                                                    item.nid
                                                                }
                                                                index={index}
                                                            >
                                                                {(
                                                                    provided,
                                                                    snapshot
                                                                ) => (
                                                                    <tr
                                                                        ref={
                                                                            provided.innerRef
                                                                        }
                                                                        {...provided.draggableProps}
                                                                        {...provided.dragHandleProps}
                                                                        style={getItemStyle(
                                                                            snapshot.isDragging,
                                                                            provided
                                                                                .draggableProps
                                                                                .style
                                                                        )}
                                                                    >
                                                                        <td>
                                                                            {
                                                                                item.nid
                                                                            }
                                                                            -
                                                                            {
                                                                                item.field_position
                                                                            }
                                                                        </td>
                                                                        <td>
                                                                            {
                                                                                item.title
                                                                            }
                                                                        </td>
                                                                        <td>
                                                                            <img
                                                                                style={{
                                                                                    width: 'auto',
                                                                                    height: '50px',
                                                                                }}
                                                                                src={`https://portal.ok-television.com${item.field_imagen}`}
                                                                            ></img>
                                                                        </td>
                                                                        <td>
                                                                            <img
                                                                                style={{
                                                                                    width: 'auto',
                                                                                    height: '50px',
                                                                                }}
                                                                                src={`https://portal.ok-television.com${item.field_imagen_para_telefonos_y_ta}`}
                                                                            ></img>
                                                                        </td>
                                                                        <td>
                                                                            <div>
                                                                                <FormCheck
                                                                                    id={`publish-${item.nid}-item`}
                                                                                    onChange={(
                                                                                        e
                                                                                    ) => {
                                                                                        handleToggleBanner(
                                                                                            item.nid,
                                                                                            e
                                                                                                .target
                                                                                                .checked
                                                                                        )
                                                                                    }}
                                                                                    {...(item.field_active_banner ===
                                                                                    'On'
                                                                                        ? {
                                                                                              checked: true,
                                                                                          }
                                                                                        : {})}
                                                                                    type="checkbox"
                                                                                />
                                                                            </div>
                                                                        </td>
                                                                        <td>
                                                                            <div>
                                                                                <Link
                                                                                    className="pr-1"
                                                                                    to={`/operadores/banners/formulario`}
                                                                                    state={{
                                                                                        lastPosition:
                                                                                            lastPosition,
                                                                                        banners:
                                                                                            banners,
                                                                                        banner: item,
                                                                                        isEdit: true,
                                                                                        isCreate: false,
                                                                                        title: t('edit_banner')
                                                                                    }}
                                                                                >
                                                                                    <OverlayTrigger
                                                                                        overlay={
                                                                                            <Tooltip id="tooltip-disabled">
                                                                                                {t('edit')}
                                                                                            </Tooltip>
                                                                                        }
                                                                                    >
                                                                                        <span className="d-inline-block">
                                                                                            <Button variant="btn-rounded outline-secondary btn-icon">
                                                                                                <i className="mdi mdi-pencil btn-icon-prepend text-info"></i>
                                                                                            </Button>
                                                                                        </span>
                                                                                    </OverlayTrigger>
                                                                                </Link>

                                                                                <OverlayTrigger
                                                                                    overlay={
                                                                                        <Tooltip id="tooltip-disabled">
                                                                                            {t('delete')}
                                                                                        </Tooltip>
                                                                                    }
                                                                                >
                                                                                    <span className="d-inline-block">
                                                                                        <Button
                                                                                            variant="btn-rounded outline-secondary btn-icon"
                                                                                            onClick={(
                                                                                                event
                                                                                            ) => {
                                                                                                event.preventDefault()
                                                                                                setSelectedBanner(
                                                                                                    item
                                                                                                )
                                                                                                setShowDeleteBanner(
                                                                                                    true
                                                                                                )
                                                                                            }}
                                                                                        >
                                                                                            <i className="mdi mdi-delete btn-icon-prepend text-danger"></i>
                                                                                        </Button>
                                                                                    </span>
                                                                                </OverlayTrigger>
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                )}
                                                            </Draggable>
                                                        )
                                                    )}
                                                    {provided.placeholder}
                                                </tbody>
                                            </Table>
                                        </div>
                                    )}
                                </Droppable>
                            </DragDropContext>
                        </div>
                    </div>
                </div>
                {/* Modal delete user starts */}
                <Modal
                    show={showDeleteBanner}
                    onHide={() => setShowDeleteBanner(false)}
                    aria-labelledby="example-modal-sizes-title-md"
                >
                    <Modal.Header closeButton>
                        <Modal.Title>{t('delete_banner_title')}</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <p>
                            <Trans
                                i18nKey="delete_banner_description"
                                values={{ banner: selectedBanner?.title, operator: selectedOperator?.group_name }}
                            />
                        </p>
                    </Modal.Body>

                    <Modal.Footer className="flex-wrap">
                        <Button
                            variant="danger m-2"
                            onClick={() => handleDeleteBanner(selectedBanner)}
                        >
                            {t('button.delete')}
                        </Button>
                        <Button
                            variant="light m-2"
                            onClick={() => setShowDeleteBanner(false)}
                        >
                            {t('button.cancel')}
                        </Button>
                    </Modal.Footer>
                </Modal>
                {/* Modal delete user Ends */}
            </div>
        </div>
    )
}

export default Banners
